import React from 'react';
import cn from 'classnames';
import hiddenStyles from '@creditflowresearch/uilib/styles/helpers/hidden.module.scss';
import panelGroupStyles from './panelGroup.module.scss';

interface IProps {
  id: string,
  labelledBy: string,
  destroyOnToggle: boolean,
  prefixCls: string,
  isActive: boolean,
  children: React.ReactNode,
  contentClass?: string,
}

const PanelContent = ({
  id,
  labelledBy,
  destroyOnToggle,
  prefixCls,
  isActive,
  children,
  contentClass = '',
}: IProps) => {
  if (!isActive && destroyOnToggle) {
    return null;
  }

  const contentCls = cn(
    panelGroupStyles.panelGroupContent,
    {
      [`${ prefixCls }Content`]: true,
      [panelGroupStyles.panelGroupContentActive]: isActive,
      [`${ prefixCls }ContentActive`]: isActive,
      [`${ prefixCls }ContentInactive`]: !isActive,
      [hiddenStyles.hidden]: !isActive,
    },
    contentClass,
  );

  return (
    <div
      id={ id }
      className={ contentCls }
      role="tabpanel"
      aria-labelledby={ labelledBy }
    >
      { children }
    </div>
  );
};

export default PanelContent;
